/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1ffee91806cde9097a44903ae9cdfd49>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _iconNew = _interopRequireDefault(require("@atlaskit/icon/components/icon-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "AiAgentAdd".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/ai-agent-add
 * Usage guidance:
 * Reserved for adding AI agents in Atlassian apps
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const AiAgentAddIcon = props => /*#__PURE__*/_react.default.createElement(_iconNew.default, Object.assign({
  name: "AiAgentAddIcon",
  dangerouslySetGlyph: `<path fill="currentcolor" d="M8 1.708a.5.5 0 0 0-.257.07l-5 3a.5.5 0 0 0-.243.43v5.584a.5.5 0 0 0 .243.428l5 3a.5.5 0 0 0 .514 0l5-3a.5.5 0 0 0 .243-.428V8H15v2.792a2 2 0 0 1-.97 1.715l-5 3c-.634.38-1.426.38-2.06 0l-5-3A2 2 0 0 1 1 10.792V5.208a2 2 0 0 1 .97-1.715l5-3A2 2 0 0 1 8 .208z"/><path fill="currentcolor" d="M10.75 11a2.75 2.75 0 1 0-5.5 0 2.75 2.75 0 0 0 5.5 0m1.5 0a4.25 4.25 0 1 1-8.5 0 4.25 4.25 0 0 1 8.5 0M13.5 0v2.25h2.25v1.5H13.5V6H12V3.75H9.75v-1.5H12V0z"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
AiAgentAddIcon.displayName = 'AiAgentAddIcon';
var _default = exports.default = AiAgentAddIcon;